/*
 *
 * File JS per la Homepage
 *
 */

import './general.scss';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from 'components/header/header';
import heroSlider from 'imComponents/hero-slider/hero-slider';
import heroImage from 'imComponents/hero-image/hero-image';
import button from 'components/buttons/buttons';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import cmsContent from 'components/cms-content/cms-content';
import footer from 'components/footer/footer';
import contactForm from 'components/contact-form/contact-form';
import cardIconText from 'components/cards/card-icon-text';
import iconTextList from 'components/icon-text-list/icon-text-list';
import textImgVar from 'imComponents/text-img-var/text-img-var';
import textOnBg from 'imComponents/text-on-bg/text-on-bg';
import modal from 'imComponents/modal/modal';
import accordion from 'imComponents/accordion/accordion';
import titleBox from 'components/title-box/title-box';
import customAccordion from 'components/custom-accordion/custom-accordion';
import colTitleText from 'components/col-title-text/col-title-text';
import banner from 'components/banner/banner';
import boxModules from 'components/box-modules/box-modules';
import staffAccordion from 'components/staff-accordion/staff-accordion';
import textIframe from 'components/text-iframe/text-iframe';
import staff from 'components/staff/staff';
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector('body.wp-admin')) {
        initHeader();
        heroSlider();
    }
    accordion();
    modal();
    iconTextList();
    staffAccordion();
}
if (document.querySelector('body.wp-admin')) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction('render_block_preview', initBlock);
        }
    })(jQuery);
}
initAllComponents();
//--------------------------------------------------------------------//
